import { SupportedCountryCodes } from '../constants/location';

export interface CountryProps {
  code: SupportedCountryCodes;
  name: string;
  localName: string;
  /* further props e.g flag, emoji ...etc */
}

export type CountryDetailsProps = Pick<Record<SupportedCountryCodes, CountryProps>, 'DE' | 'AT'>;

export type CountryCode = keyof CountryDetailsProps;

export const CountryDetails: CountryDetailsProps = {
  DE: { code: 'DE', name: 'Germany', localName: 'Deutschland' },
  AT: { code: 'AT', name: 'Austria', localName: 'Österreich' },
};
